module.exports = __webpack_public_path__ + "img/D202103_2.67ba507d.jpg";